// src/utils/isPlainObject.ts
/**
* Narrows `unknown` to a string-keyed object — a non-null value of `typeof 'object'`
* that is not an array. Note it does not distinguish class instances (e.g. `Date`) from
* object literals; it only rules out `null`, arrays, and primitives.
*/
const isPlainObject = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
export { isPlainObject as t };

//# sourceMappingURL=isPlainObject-BxsT8_t2.js.map